<template>
	<div ref="pickets" v-parallax-fit="parallax" class="pickets">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/25_Protest@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';
export default {
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/6.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/6_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 34000,
					end: 35700,
					fromStyle: { transform: 'translateY(500%) scale(0)' },
					toStyle: { transform: 'translateY(50%) scale(1.5)' },
					easing: 'linear'
				},
				{
					start: 36600,
					end: 37600,
					fromStyle: { transform: 'translateY(50%) scale(1.5)' },
					toStyle: { transform: 'translateY(500%) scale(0)' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART8_9_010723.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/8b.png',
					url: 'https://www.michigan.gov/mshda/-/media/Project/Websites/mshda/homeownership/Counseling/Foreclosure-Timeline-212022.pdf?rev=f51162f7cc3c4887ba38841bb2bcfe68&hash=64BBAF8E6159CF4F0F7C866F1F71A878',
					link_title: {
						'en': "Foreclosure Timeline",
						'es': 'Cronología de la ejecución hipotecaria'
					},
				},
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/8b.png',
					url: 'https://www.michigan.gov/mshda/homeownership/homeowners/stages-of-foreclosure',
					link_title: {
						'en': "Stages of Foreclosure",
						'es': 'Etapas de ejecución hipotecaria'
					},
				}
			],
			text: {
				'en': 'Redemption Period starts day of the sheriff sale - six (6) months is most common...Homeowner can live in property, not required to make payments, can sell or buy back property and should: maintain the property, maintain utilities, maintain insurance. To redeem the property the borrower must pay the amount bid at the sheriff sale + interest + fees.',
				'es': 'El período de redención comienza el día de la venta del sheriff: seis (6) meses es lo más común... El propietario puede vivir en la propiedad, no está obligado a realizar pagos, puede vender o recomprar la propiedad y debe: mantener la propiedad, mantener los servicios públicos, mantener el seguro . Para redimir la propiedad, el prestatario debe pagar el monto ofertado en la venta del sheriff + intereses + cargos.'
			}
		};

		const text = {
			'en': "The redemption process allows homeowners whose homes were sold at auction to essentially buy back their home. Usually, they have a 6 month time period during which they must pay the amount their home was sold for auction in addition to other fees and interest.",
			'es': 'El proceso de redención permite a los propietarios cuyas casas se vendieron en una subasta esencialmente volver a comprar su casa. Por lo general, tienen un período de tiempo de 6 meses durante el cual deben pagar el monto de la subasta de su casa, además de otros cargos e intereses.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(50%) scale(1.5)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					this.$evidence.value = JSON.stringify(evidence);
					this.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(this.$refs.pickets, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.pickets {
	position: absolute;
	left: 0;
	bottom: 0;
	min-width: 900px;
	transition: all 0.6s linear;
	margin-left: -150px;
}

@media screen and (max-width: 1600px) {
	.pickets {
		min-width: 750px;
		margin-left: -110px;
	}
}

@media screen and (max-width: 991px) {
	.pickets {
		min-width: 650px;
		margin-left: -110px;
		bottom: -60px;
	}
}

@media screen and (max-width: 650px) {
	.pickets {
		min-width: 380px;
		max-width: 380px;
		margin-left: -25px;
		bottom: -82px;
	}
}
</style>
